import { Analytics } from "@vercel/analytics/react"

import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import { Perf } from 'r3f-perf'
import { StrictMode, Suspense } from 'react'

import Loader from './Components/Loader.jsx'
import App from './App.jsx'
import './index.css'

console.log("Connect with Gopi Krishnan: mistercalifornia007@gmail.com | GitHub: https://github.com/gopiO-O")


const isMobile = () => {
    return ( ( window.innerWidth <= 1000 ) && ( window.innerHeight <= 800 ) );
  }

const root = ReactDOM.createRoot(document.querySelector('#root'))

const fovForMobile = 100
const fovForPc = 45

root.render(
    <StrictMode>
        <Canvas
            camera={{
            fov: isMobile() ? fovForMobile : fovForPc,
            near: 0.1,
            far: 200,
            position: [52, 7, 12],
        }}
        >
            <Suspense fallback={<Loader/>}>
                <App/>   
            </Suspense>

            {/*<Perf position="top-left" />*/}
        </Canvas>

        <Analytics/>
        <div style={{ display: "none" }}>
  <section aria-hidden="true">
    <h1>Gopi Krishnan - Cloud Infrastructure & DevOps Engineer</h1>
    <h2>Cloud & DevOps Engineer at Karuviyan Innovatives</h2>
    <h2>Bachelor of Engineering in ECE - KIT KalaignarKarunanidhi Institute of Technology</h2>
    <h2>Specialized in AWS, Azure, Kubernetes, Terraform, CI/CD, and Cloud Security</h2>
  </section>
  <section aria-hidden="true">
    <h2>Skills and Expertise</h2>
    <ul>
      <li>Cloud Architecture: AWS & Azure</li>
      <li>Containerization & Orchestration: Docker, Kubernetes, Helm, Amazon EKS, ArgoCD</li>
      <li>Infrastructure as Code: Terraform, Ansible</li>
      <li>CI/CD Automation: Jenkins Pipelines, GitHub Actions</li>
      <li>Monitoring & Observability: Prometheus, Grafana, AWS CloudWatch</li>
      <li>Operating Systems & Scripting: Linux, Windows Server, Bash, Python</li>
      <li>Security & Networking: IAM, VPC, TLS, Burp Suite, Nmap, Wireshark</li>
    </ul>
  </section>
  <section aria-hidden="true">
    <p>
      Welcome to the 3D portfolio of Gopi Krishnan. This immersive portfolio showcases 
      production cloud infrastructure, Kubernetes microservices, CI/CD automation, 
      and innovative DevOps solutions.
    </p>
  </section>
  <noscript>
    <p>
      This 3D portfolio of Gopi Krishnan showcases Cloud & DevOps engineering. 
      Please enable JavaScript to explore the immersive experience.
    </p>
  </noscript>
</div>



    </StrictMode>

        
    
)